import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from "react";
import Api from "../../services/Api";
import {useNavigate} from "react-router";
import {ClientInterface} from "../../interfaces/common";
import { useAtom } from "jotai";
import { unreadCoachChatsAtom } from "../../jotai_state";
import profileIcon from "url:shared-assets/icons/profile.svg";
import iconCalendar from "url:shared-assets/icons/calendar.svg"
import {getLanguage} from "../../lang/helpers";


export default function ClientPage() {

  const api = Api.getInstance();
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language);
  const navigate = useNavigate();
  const [clients, setClients] = useState<Array<ClientInterface>>([]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [unreadChats] = useAtom(unreadCoachChatsAtom);

  useEffect(() => {
    api.get('coach/clients').then((result) => {
      setClients(result.json.clients)
      setLoaded(true)
    })
  }, []);

  return (
    <div className="main-content">
      <h2 className="mt-4 text-lg font-medium">{t('my-clients')}</h2>

      {
        loaded ? (
          <>
            {
              clients.filter(client => client.dateTo === null).map((client, idx) => {
                const unreadChat = unreadChats.indexOf(client.id) > -1;
                return (
                  <div key={"client_" + idx} className="mt-4 flex justify-between">
                    <div className="cursor-pointer flex items-center"
                         onClick={() => navigate('/clients/' + client.id)}>
                      <img className="picture" alt="pic"
                           src={client.picture ? client.picture : profileIcon}/>
                      <div className="ml-4">
                        <p className="text-lg font-medium">{client.firstName} {client.lastName}</p>
                        <p className="text-neutral-400">{client.title} | {client.company}</p>
                      </div>
                    </div>
                    <div className="flex gap-x-2">
                    {
                      client.bookedMeetings > 0 &&
                        <img src={iconCalendar} alt="booked" className="picture-xs"/>
                    }
                    {
                      unreadChat &&
                        <div className="rounded-full h-2 w-2 bg-cherry-500"/>
                    }
                    </div>
                  </div>
                )
              })
            }
            {
              clients.length === 0 &&
                <div className="mt-4">
                  {lang === 'sv' ? 'Här visas de klienter som valt dig' : 'Here you will see the clients who selected you'}
                </div>
            }
            {
              clients.filter(client => client.dateTo !== null).length > 0 &&
                <h2 className="mt-6 text-lg font-medium">{lang === 'sv' ? 'Avslutade klienter' : 'Finished clients'}</h2>
            }
            {
              clients.filter(client => client.dateTo !== null).map((client, idx) => {
                return (
                  <div key={"client_" + idx} className="mt-4 flex justify-between">
                    <div className="cursor-pointer flex items-center"
                         onClick={() => navigate('/clients/' + client.id)}>
                      <img className="picture" alt="pic"
                           src={client.picture ? client.picture : profileIcon}/>
                      <div className="ml-4">
                        <p className="text-lg font-medium">{client.firstName} {client.lastName}</p>
                        <p className="text-neutral-400">{client.title} | {client.company}</p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </>
        ) : (
          <div className="mt-4">Loading clients...</div>
        )
      }
    </div>
  )
}